import UserThumbnail from '@atom/components/common/UserThumbnail';
import { UserDetail } from '@atom/types/user';
import { getUserFullName } from '@atom/utilities/userUtilities';

import classes from './workOrder.module.css';

export type UserRowProps = { user: UserDetail };

const UserRow = ({ user }: UserRowProps) => (
  <div className={classes.userRow}>
    <UserThumbnail image={user.photoUrl} alt={getUserFullName(user)} />
    <div>
      <div className={classes.userRowName}>{getUserFullName(user)}</div>
      <div className={classes.userRowEmail}>{user.email}</div>
    </div>
  </div>
);

export default UserRow;
